import {required} from 'redux-form-validators';

export default opts =>
  required({
    message: {
      id: 'validation.required'
    },
    ...opts
  });



// WEBPACK FOOTER //
// ./validators/units/required.js